import React from 'react';
import styled from 'styled-components';
import {CardTitle, OutlineButton, P2} from '../Kit/Kit';
import frozenIcon from '../../assets/img/frozenIcon.jpg';
import freshIcon from '../../assets/img/freshIcon.jpg';
import {BodyContainer} from "../Container/Container";
import Link from 'gatsby-link';

const StyledBodyContainer = BodyContainer.extend`
    //margin-top: 60px;

    @media(min-width: 768px){
      margin-top: 50px;
    }
    
`;

const Container = styled.div`
  padding-top: 50px;
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  grid-column-gap: 24px;
  position: relative;
  margin-bottom: 32px;
  
  @media(min-width: 768px) {
    grid-template-columns: 1fr 2fr ;
    padding-top: 150px;
    margin-bottom: 100px;
  }
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  order: 2;
  z-index: 2;
  
  @media(min-width: 768px) {
    order: 1;
  }
`;

const Name = CardTitle.extend`
  margin-right: 12px;
`;

const NameContainer = styled.div`
  display: flex;
  align-items: center;
`;

const Summary = P2.extend`
  text-align: left;
  margin: 12px 0 30px
`;

const FreshIcon = styled.img`
  margin-right: 10px;
  display: ${props => props.render ? 'block' : 'none'}
`;

const FrozenIcon = FreshIcon.extend`

`;

const ProductImg = styled.img`
  width: 100%;
  order: 1;
  z-index: 1;
  
`;

const BackgroundText = styled.div`
  display: none;
  position: absolute;
  top: 0;
  color: #f6f6f6;
  font-family: Cabin-Bold, sans-serif;
  z-index: 1;
  
  @media(min-width: 768px) {
    display: block;
    font-size: 75px;
  }
  
  @media(min-width: 992px) {
    font-size: 100px;
    left: 0
  }
  
  @media(min-width: 1200px) {
    font-size: 125px;
  }
  
  @media(min-width: 1680px) {
    font-size: 170px;
  }
`;

const OtherImg = styled.div`
  display: ${props => props.visible ? 'grid' : 'none'};
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 30px;
  
  @media(min-width: 992px) {
    grid-template-columns: repeat(4, 1fr);
  }

  img {
    width: 100%;
  }
`;

const SingleHeader = (props) => {
    const {
        title,
        description,
        fresh,
        frozen,
        main_image,
        gallery_visible,
        image_one,
        image_two,
        image_three,
        image_four
    } = props.data;
    return (
      <StyledBodyContainer>
          <Container>
              <BackgroundText>{title}</BackgroundText>
              <ProductImg
                src={main_image.source_url}
                alt={main_image.alt_text}
              />
              <TextContainer>
                  <NameContainer>
                      <Name>{title}</Name>
                      <FreshIcon
                        src={freshIcon}
                        alt="fresh icon"
                        render={fresh}
                      />
                      <FrozenIcon
                        src={frozenIcon}
                        alt="frozen icon"
                        render={frozen}
                      />
                  </NameContainer>
                  <Summary
                    dangerouslySetInnerHTML={{__html: description}}
                  />
                  <Link to="/connect"
                        title="Get In Touch With H & N Group "><OutlineButton>Contact</OutlineButton></Link>
              </TextContainer>
          </Container>
          <OtherImg visible={gallery_visible}>
              <img
                src={image_one.url}
                alt={image_one.alt}
              />
              <img
                src={image_two.url}
                alt={image_two.alt}
              />
              <img
                src={image_three.url}
                alt={image_three.alt}
              />
              <img
                src={image_four.url}
                alt={image_four.alt}
              />
          </OtherImg>
      </StyledBodyContainer>
    )

};

export default SingleHeader;



// WEBPACK FOOTER //
// ./src/components/SingleProduct/SingleHeader.js